export interface ProfileCompletionState {
  verified_name: boolean
  track_id: number | null
}

export function normalizeProfileName(value: string): string {
  return value.trim().replace(/\s+/g, ' ')
}

export function isProfileComplete(state: ProfileCompletionState): boolean {
  return state.verified_name === true && typeof state.track_id === 'number'
    && Number.isInteger(state.track_id) && state.track_id > 0
}

export function getProfileLandingPath(pathname: string, profileComplete: boolean): string {
  return !profileComplete && pathname !== '/' ? '/' : pathname
}
